export class Content {
    constructor() {
        this.value = "";
        this.value = "";
    }
}
//# sourceMappingURL=Content.js.map